

























import {defineComponent} from "@vue/composition-api";
import {useGetters} from "vuex-composition-helpers";

export default defineComponent({
    name: 'Events',
    setup: () => {
      const { events } = useGetters(["events"]);
      return events
    }
})
